import React from 'react';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { Route } from 'react-router-dom';
import { BreadcrumbsItem } from '@app/layouts/layout';
import { QmStatisticOutlet } from '@app/pages/qm-module';
import QmStatisticMainWidgets from '@app/pages/qm-module/qm-statistic/blocks/qm-statistic-main-widgets';
import {
  MonitoringTapContent,
  OperatorsTapContent,
  TeamsTapContent,
} from '@app/pages/qm-module/qm-statistic/blocks/tap-blocks';

export const qmStatisticRoute = (
  <Route
    path={navigationRoutes.qm_module_statistic}
    handle={{
      crumb: () => (
        <BreadcrumbsItem path={navigationRoutes.qm_module_statistic} crumb="qm_statistic" />
      ),
    }}
    element={<QmStatisticOutlet />}
  >
    <Route index element={<QmStatisticMainWidgets />} />
    <Route id="monitoring" path="monitoring/:id/:count?" element={<MonitoringTapContent />} />
    <Route path="operators/:mform_id?/:team_id?/:count?" element={<OperatorsTapContent />} />
    <Route path="teams/:mform_id/:count?" element={<TeamsTapContent />} />
  </Route>
);
